module.exports = __webpack_public_path__ + "static/where-map-mobile-c2b9595602717e2a55fe74d616efafd8.svg";